<template>
  <div class="container">
    <PullRefresh
      v-model="isLoading"
      success-text="刷新成功"
      :disabled="disabledPull || activityInfo.activityStatus !== 1"
      @refresh="onRefresh"
    >
      <div v-if="!isLive" class="pageNative flex_center">
        <div
          v-if="activityInfo.activityStatus === 0 && hasFetched"
          class="nativeStatus flex_center"
        >
          活动将于 {{ activityInfo.startTime }} 开始
        </div>
        <div class="nativeStatus flex_center" v-else>活动已结束</div>
      </div>
      <div v-else class="page pb_24" :class="{ pt_120: activityInfo.banner && hasFetched }">
        <div class="page_header">
          <img
            v-if="activityInfo.banner"
            class="page_banner"
            :src="activityInfo.banner"
          />
        </div>
        <div class="page_desc box_wrap z_index_1">
          <div class="page_desc_title box_header" style="padding-bottom: 2px;">
            <img style="height: 25px;" :src="`${CDN_URL}/title2.png`" />
          </div>
          <div class="page_desc_content box_ctx">
            <div class="page_desc_item">
              <div class="page_desc_icon">TIP1</div>
              <div class="page_desc_label">活动介绍</div>
              <div class="page_desc_value">{{ activityInfo.introduce }}</div>
            </div>
            <div class="page_desc_item">
              <div class="page_desc_icon">TIP2</div>
              <div class="page_desc_label">活动时间</div>
              <div class="page_desc_value">{{ activityInfo.timeDesc }}</div>
            </div>
            <div class="page_desc_item">
              <div class="page_desc_icon">TIP3</div>
              <div class="page_desc_label">奖励领取</div>
              <div class="page_desc_value">{{ activityInfo.rewardDesc }}</div>
            </div>
          </div>
        </div>
        <div class="games_wrap box_wrap z_index_1">
          <div class="box_header" style="padding-top: 4px; padding-bottom: 2px;">
            <img style="height: 36px;" :src="`${CDN_URL}/title1.png`" />
          </div>
          <div class="games box_ctx">
            <div
              v-for="game in activityInfo.gameInfoVos"
              :key="game.gameId"
              class="game_item van-hairline--bottom"
            >
              <div
                class="game_icon bg_contain"
                :style="{
                  backgroundImage: `url(${game.icon})`
                }"
              ></div>
              <div class="game_desc">
                <div class="game_name">{{ game.gameName }}</div>
                <div class="game_tags scale08">
                  <div
                    v-for="(tag, tIdx) in game.tags"
                    :key="tIdx"
                    class="game_tag fs_12"
                    :style="{
                      border: `1px solid ${tag.labelInfo || '#000'}`,
                      color: tag.labelInfo
                    }"
                  >
                    {{ tag.labelName }}
                  </div>
                </div>
                <div class="game_extra fs_12 scale08_bot">
                  <div class="game_score van-hairline--right">{{ game.score }}分</div>
                  <div class="game_verson">{{ game.version }}版本</div>
                </div>
              </div>
              <div class="game_btn" @click="handleGoGame(game)">
                前往查看
              </div>
            </div>
          </div>
        </div>
      </div>
    </PullRefresh>
  </div>
</template>

<script>
import { 
  getBtGameTesterHomeApi,
} from '@/apis/btBoxActivity' 
import { setPageTitle } from "@/bridge/AppJsBridge";
import { PullRefresh } from "vant";
import EventTrack from '@/mixins/eventTrack'
import { CDN_URL_1 } from "@/config";
export default {
  components: {
    PullRefresh,
  },
  mixins: [EventTrack],
  data () {
    return {
      CDN_URL: CDN_URL_1 + '/box_bt_game_tester',
      isLoading: false,
      disabledPull: false,
      hasFetched: false,
      activityInfo: {},
    }
  },
  computed: {
    isLive () {
      if (!this.hasFetched) return true
      if (!this.activityInfo.activityId && this.hasFetched) return false
      return this.activityInfo.activityStatus === 1
    },
    trackActInfo () {
      return JSON.stringify({
        activity_id: this.activityInfo.activityId,
        activity_name: this.activityInfo.name,
      })
    },
    actId () {
      return this.$route.query.id
    },
  },
  mounted () {
    this.getAppToken(true)
  },
  activated () {
    this.init()
    setPageTitle(this.activityInfo.title)
  },
  methods: {
    getActivityInfo () {
      this.init()
    },
    init () {
      return this.getActInfo().then(res => {
        setPageTitle(this.activityInfo.name)
        this.eventTrack({
          event: 'taste_activity_home_page',
          event_field: this.trackActInfo,
        })
      })
    },
    onRefresh () {
      this.init().then(res => {
        this.isLoading = false
      })
    },
    // 获取活动详情
    getActInfo () {
      return getBtGameTesterHomeApi({
        activityId: this.actId,
      }).then(res => {
        this.activityInfo = res.data || {
          activityId: '',
          activityStatus: 2,
          banner: "",
          introduce: "",
          startTime: "2022-01-01",
          name: "",
          gameInfoVos: [],
        }
      }).finally(() => {
        this.hasFetched = true
      })
    },
    handleGoGame ({ gameId, gameName, activityGameId }) {
      this.eventTrack({
        event: 'taste_activity_to_view_button',
        event_field: this.trackActInfo,
        appName: gameName,
        appkey: gameId,
      })
      this.$router.push({
        name: 'box.gameTester.game',
        query: {
          activityGameId: activityGameId,
          fromHome: true, // 区分下是从主页进入还是从其他页面进入
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
.pageNative {
  width: 100vw;
  height: 100vh;
}
.games {
  
}
</style>